export interface AppInitialStateType {
  headerHeight: number;
  hamburgerMenu: boolean;
}

export const AppInitialState: AppInitialStateType = {
  headerHeight: 70,
  hamburgerMenu: false,
}

export const actionTypes = {
  SET_HEADER_HEIGHT: 'SET_HEADER_HEIGHT',
  SET_HAMBURGER_MENU: 'SET_HAMBURGER_MENU',
}


export const AppReducer = (state: any, action: any) => {

  switch (action.type) {
    case actionTypes.SET_HEADER_HEIGHT:
      return {
        ...state,
        isCmsLoading: action.payload
      } as AppInitialStateType;
    case actionTypes.SET_HAMBURGER_MENU:
      return {
        ...state,
        hamburgerMenu: action.payload
      } as AppInitialStateType;
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

